// removed by extract-text-webpack-plugin
module.exports = {"btn-apex-primary":"_1UiVtkhBLLRDAU89stj8ie","focus":"_2WoGjyYktvyDlT7s93OYwU","active":"_3eybS6TK0hUI7aL8yPrdJb","disabled":"_2HpYBJlgFRQ0G6wwFGAsgy","badge":"_2eJguNlT5YH-enykrlnRg6","btn-apex-secondary":"_1YbKHnhM8z4azOckp3TJd1","btn-apex-secondary-no-hover":"_3Uu3hSqNNDdlc1zFLj3H70","btn-apex-negative":"x2Pmm4gs8RU1IOdk6Hpf7","btn-apex-orange":"_2Ela7Vq3VIYqbpiRfbp-it","defList":"_2gufwlUd3MnL-W0McA8P4Z","editDescriptions":"_2zBX1cm65CScxQPh5J8Dwl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WireDescriptionsPanel/styles.css
// module id = 3244
// module chunks = 0